import classNames from 'classnames'

import { CommonBookingIcon } from '@local/assets/icons'
import { MarkerPlaceDotIcon, MarkerVisitedIcon } from '@local/assets/icons/marker-cleanup'

import styles from './DotWithIconMarker.module.scss'
export interface DotWithIconMarkerProps {
  isSelected?: boolean
  name?: string
  text?: string
  ellipsis?: boolean
  type?: 'booking' | 'visited' | 'normal'
}

const DotWithIconMarker = ({
  name,
  text,
  isSelected = false,
  ellipsis = false,
  type = 'normal',
}: DotWithIconMarkerProps) => {
  const getIconType = (type = '') => {
    if (type === 'booking') return <CommonBookingIcon className={styles.icon} aria-hidden="true" />

    if (type === 'visited') return <MarkerVisitedIcon className={styles.icon} aria-hidden="true" />

    return <MarkerPlaceDotIcon className={styles.icon} aria-hidden="true" />
  }

  return (
    <div className={classNames(styles.dot_marker, styles[`type_${type}`], { [styles.selected]: isSelected })}>
      <div className={styles.marker_inner}>
        <div className={styles.marker_area}>
          <div className={styles.icon_area}>{getIconType(type)}</div>
        </div>
        <div className={styles.info_area}>
          <div className={styles.tit_area}>
            <div className={classNames(styles.tit_inner, { [styles.type_ellipsis]: ellipsis })}>
              <span className={styles.name}>{name}</span>
            </div>
          </div>
          {text && (
            <div className={styles.date_area}>
              <span className={styles.txt}>{text}</span>
            </div>
          )}
        </div>
        {isSelected && <span className="place_blind">선택됨</span>}
      </div>
    </div>
  )
}

export default DotWithIconMarker
